import React from "react";
import Table from "../../components/subcomponents/table";
import FormHeader from "../../components/subcomponents/formheader";
import { connect } from "react-redux";
import race_current from "../../api/race";
import race_history from "../../api/race_history";
import controller from "../../api/controller";
import TableControl from "../../components/subcomponents/table_control";
import SubformDetails from "../../components/subcomponents/subform_details";
import isPermitted from "../../permissions/permissions";

class eventsList extends React.Component {
    componentDidMount() {
        controller.list();
        race_current.events_list();
        race_history.list();
        race_history.options();
        this.props.handleSelect(false);
        if (isPermitted("Admin")) {
            this.props.handleFilter({name: "company_id", value: this.props.user.company_id})
        }
    }
    selectEvent(id) {
        this.props.handleSelect(id);
        this.props.history.push("/event/details");
    }
    selectHistoryEvent(id) {
        this.props.handleHistorySelect(id);
        this.props.history.push("/event/history_details");
    }
    showCurrentList() {
        let data = [];
        if (this.props.history_events_filter["company_id"]) {
            data = this.props.events_list.filter(controller=>controller.company_id === this.props.history_events_filter["company_id"])
        } else
        data = this.props.events_list
        return (
            <SubformDetails title="EVENTS LIST" className="details width_100">
                <div className="module_block_wrap">
                    <Table
                        name="race_details"
                        table_key={"cntrl_id"}
                        selected={this.props.event_selected}
                        handleSelect={this.selectEvent.bind(this)}
                        headers={{
                            cntrl_id: { label: "Ctrl", width: "10%" },
                            alias: { label: "Alias", width: "10%" },
                            state: { label: "State", width: "7%" },
                            name: { label: "Run", width: "25%" },
                            track_name: { label: "Track", width: "12%" },
                            track_length: { label: "Length,km", width: "5%" },
                            race_type: { label: "Type", width: "9%" },
                            flag: { label: "Flag", width: "10%" },
                            server_time: { label: "Updated at", width: "12%" },
                        }}
                        data={data}
                    />
                </div>
            </SubformDetails>
        );
    }
    showHistoryList() {
        const filter = (isPermitted("Admin"))
            ? { options: this.props.history_events_options["company_id"], value: this.props.history_events_filter["company_id"] }
            : null
        return (
            <SubformDetails title="HISTORY LIST" className="details width_100">
                <TableControl
                    search={this.props.search_string}
                    filter={filter}
                    navigation={this.props.navigation}
                    handleSearch={this.props.handleSearch}
                    handleSetRPP={this.props.handleSetRPP}
                    handleSetPage={this.props.handleSetPage}
                    handleFilter={this.props.handleFilter}
                />
                <div className="module_block_wrap">
                    <Table
                        name="race_details"
                        table_key={"id"}
                        selected={this.props.history_event_selected}
                        handleSelect={this.selectHistoryEvent.bind(this)}
                        headers={{
                            id: { label: "ID", width: "3%" },
                            company_name: { label: "Company", width: "10%" },
                            championship: { label: "Event", width: "20%" },
                            name: { label: "Run", width: "20%" },
                            track_name: { label: "Track", width: "15%" },
                            track_length: { label: "Length,km", width: "10%" },
                            race_type: { label: "Type", width: "10%" },
                            start_time: { label: "Started", width: "7%" },
                            end_time: { label: "Ended", width: "7%" },
                            date: { label: "Date", width: "8%" },
                        }}
                        data={this.props.history_events_list}
                    />
                </div>
            </SubformDetails>
        );
    }
    render() {
        return (
            <div className="form_wrap races_list">
                <FormHeader title="RACES LIST" />
                {this.showCurrentList()}
                {this.showHistoryList()}
            </div>
        );
    }
}

function stateArr(obj = {}) {
    let state_arr = [];
    Object.keys(obj).forEach((field) => {
        state_arr.push(obj[field]);
    });
    return state_arr;
}

function getControllerAlias(controllers_list, controller_id) {
    //controller_id is actually mac need refactor
    let result = controllers_list.find(
        (controller) => controller.controller_mac === controller_id
    );
    return result?.controller_alias ?? "NOT FOUND";
}

function mapStateToProps(state) {
    let events = state.raceR.events;
    let controllers_list = state.controllerR.controller.list;
    let history_events = state.raceR.history_events;
    let events_list = stateArr(state.raceR.race_details);
    let user = state.authR.user;
    if (controllers_list.length)
        events_list.forEach((event) => {
            event.alias = getControllerAlias(controllers_list, event.cntrl_id);
        });
    return {
        events_list: events_list,
        history_events_list: history_events.list,
        history_events_options: history_events.options,
        history_events_filter: history_events.filter,
        event_selected: events.selected,
        search_string: history_events.search_string,
        navigation: history_events.list_pagination,
        refresh: state.raceR.refresh,
        user: user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        handleSearch(result) {
            dispatch({
                type: "HISTORY_EVENT_DESELECTED",
            });
            dispatch({
                type: "HISTORY_EVENT_UPDATE_SEARCH_STRING",
                value: result.value,
            });
            race_history.list();
        },
        handleFilter(result) {
            dispatch({
                type: "HISTORY_EVENT_DESELECTED",
            });
            dispatch({
                type: "HISTORY_EVENT_UPDATE_FILTER_STRING",
                value: result.value ? { [result.name]: result.value } : {},
            });
            race_history.list();
        },
        handleSetRPP(result) {
            dispatch({
                type: "HISTORY_EVENT_RPP_CHANGED",
                value: result.value,
            });
            race_history.list();
        },
        handleSetPage(value) {
            dispatch({
                type: "HISTORY_EVENT_SET_PAGE",
                value: value,
            });
            race_history.list();
        },
        handleSelect(id) {
            if (id) {
                dispatch({
                    type: "EVENT_SELECTED",
                    value: id,
                });
            } else {
                dispatch({
                    type: "EVENT_DESELECTED",
                });
            }
        },
        handleHistorySelect(id) {
            if (id) {
                dispatch({
                    type: "HISTORY_EVENT_SELECTED",
                    value: id,
                });
            } else {
                dispatch({
                    type: "HISTORY_EVENT_DESELECTED",
                });
            }
        },
    };
}

export default eventsList = connect(
    mapStateToProps,
    mapDispatchToProps
)(eventsList);
